<template>
    <ion-page>
        <ion-tabs>
            <ion-router-outlet />
            <ion-tab-bar slot="bottom" class="sportspoule-tab-bar">
                <ion-tab-button
                    tab="livescores"
                    href="/tabs/livescores"
                    class="tab livescores-tab"
                    @click="handleTabClick"
                >
                    <ion-icon
                        src="./assets/icons/live-scores.svg"
                        class="icon"
                    />
                    <ion-label>{{ $t("live-scores.index-tab") }}</ion-label>
                </ion-tab-button>

                <ion-tab-button
                    tab="groups"
                    href="/tabs/groups"
                    class="tab"
                    @click="handleTabClick"
                >
                    <ion-icon
                        src="./assets/icons/sportspoule-logo.svg"
                        class="icon"
                    />
                    <ion-label>{{ $t("group.index-tab") }}</ion-label>
                </ion-tab-button>

                <ion-tab-button
                    tab="profile"
                    href="/tabs/profile"
                    class="tab"
                    @click="handleTabClick"
                >
                    <div class="profile-image-wrapper">
                        <UserAvatar
                            :name="user?.name || ''"
                            :image-url="profilePictureUrl"
                            :size="24"
                        />
                    </div>
                    <ion-label>{{ $t("profile.profile-tab") }}</ion-label>
                </ion-tab-button>
            </ion-tab-bar>
        </ion-tabs>
    </ion-page>
</template>

<script lang="ts" setup>
    import {
        IonPage,
        IonTabBar,
        IonTabs,
        IonTabButton,
        IonLabel,
        IonIcon,
        IonRouterOutlet,
        onIonViewDidEnter,
    } from "@ionic/vue";
    import { computed } from "vue";
    import { store } from "@/store";
    import UserAvatar from "@/components/UserAvatar.vue";
    import { useHaptics } from "@/composables/useHaptics";
    import { ImpactStyle } from "@capacitor/haptics";

    const user = computed(() => store.getters["profile/user"]);
    const { impact } = useHaptics();

    const handleTabClick = () => {
        impact(ImpactStyle.Light);
    };

    const profilePictureUrl = computed<string | null>(
        () => user.value?.profilePictureUrl ?? null,
    );

    onIonViewDidEnter(async () => {
        await store.dispatch("profile/fetchUser");
    });
</script>

<style lang="scss">
    .sportspoule-tab-bar {
        box-shadow: 0px -2px 4px 0px var(--color-black-alpha-08);
    }

    .tab {
        --color: var(--ion-tab-bar-color);
        --color-selected: var(--ion-tab-bar-color-selected);

        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        font-size: 10px;
        font-weight: 600;
        font-style: normal;
        line-height: 1;
        text-align: center;
        gap: 2px;

        ion-label {
            margin: 0;
            font-size: 10px;
            font-weight: 600;
            font-style: normal;
            line-height: 1;
            text-align: center;
            color: inherit;
        }

        .icon {
            width: 24px;
            height: 24px;
            filter: grayscale(100%);
            opacity: 0.5;
            margin: 0;
            transition: all 0.125s ease-out;
        }

        &.tab-selected {
            .icon {
                opacity: 1;
                filter: none;
            }

            .profile-image-wrapper {
                filter: none;
                opacity: 1;
            }
        }

        .profile-image-wrapper {
            opacity: 0.5;
            filter: grayscale(100%);
            transition: all 0.125s ease-out;
        }
    }

    .ion-page {
        @media (min-width: 800px) {
            margin: 0 auto;
            border-right: 1px solid var(--color-black-alpha-05);
            border-left: 1px solid var(--color-black-alpha-05);
            max-width: 800px;
        }
    }
</style>
